import { HStack, Stack } from "@chakra-ui/react";
import React from "react";

import { Events } from "../ui/Events";
import { Notes } from "../ui/Notes";
import { Ability } from "./Ability";
import { CollaboratorSubTabs } from "./CollaboratorSubTabs";
import { Summary } from "./Summary";

export const CollaboratorAbilities: React.FC<{}> = () => {
  return (
    <>
      <Summary />
      <Stack bg="white" boxShadow="sm" w="full" px="6">
        <CollaboratorSubTabs />
      </Stack>
      <HStack w="full" spacing="4" alignItems="start">
        <Stack w="75%" spacing="4">
          <Ability />
        </Stack>
        <Stack w="25%" spacing="4">
          <Notes />
          <Events />
        </Stack>
      </HStack>
    </>
  );
};
